export enum BOOL_LETTER_STRING {
  Y = 'Y',
  N = 'N',
}
